export default __webpack_public_path__ + "static/media/bxl-python.b85e2899.svg";